































































import { Component, Vue} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../../lib/ajax';
import AbpBase from '../../../../../lib/abpbase';
import QuickTable from "../../../../../components/table/table.vue";
import Tools from '../../../../../lib/tools';
@Component({
	name:'safetyAccidentReport',
	components: {
		QuickTable
	}
})
export default class SafetyAccidentReport extends AbpBase {
	initData:any = {
		showModal: false,
		formLoading: false,
		organizations: [],			// 部门数据
		formData: {
			id: '',
			accidentSummary: '',
			happenDt: '',
			happenAddress: '',
			accidentLoss: '',
			accidentType: '',
			reportDepId: '',
			accidentLeader: '',
			reportDt: '',
			accidentDealInfo: ''
		},
		validate: {
			accidentSummary: [
				{ required: true, message: '请填写事故概述', trigger: 'blur' }
			],
			happenDt: [
				{ required: true, type: 'date', message: '请选择发生时间', trigger: 'blur' }
			],
			reportDepId: [
				{ required: true, type: 'number', message: '请选择上报部门', trigger: 'change' }
			],
			reportDt: [
				{ required: true, type: 'date', message: '请选择上报时间', trigger: 'change' }
			],
			accidentLeader: [
				{ required: true, message: '请填写事故责任人', trigger: 'blur' }
			],
			happenAddress: [
				{ required: true, message: '请填写事故发生地点', trigger: 'blur' }
			],
		},
		datepickerOption: {
            disabledDate (date:any) {
                return date && date.valueOf() > Date.now();
            }
        },
		columns: [
			{
				title: '序号',
				type: 'index',
				width: 60
			},
			{
				title: '事故概述',
				key: 'accidentSummary'
			},
			{
				title: '发生时间',
				key: 'happenDt',
				render: (h:any, params:any) => {
					return h('span', Tools.formatDate(params.row.happenDt));
				}
			},
			{
				title: '发生地点',
				key: 'happenAddress'
			},
			{
				title: '事故损失',
				key: 'accidentLoss'
			},
			{
				title: '事故类别',
				key: 'accidentType'
			},
			{
				title: '上报部门',
				key: 'reportDep',
				render: (h:any, params:any) => {
					return h('span', params.row.reportDep ? params.row.reportDep.displayName : '');
				}
			},
			{
				title: '事故责任人',
				key: 'accidentLeader'
			},
			{
				title: '上报时间',
				key: 'reportDt',
				render: (h:any, params:any) => {
					return h('span', Tools.formatDate(params.row.reportDt));
				}
			},
			{
				title: '事故处理情况',
				key: 'accidentDealInfo'
			},
			{
				title: '操作',
				key: 'action',
				width: 128,
				render: (h:any, params:any) => {
					return h('div', [
						h('Button', {
							props: {
								type: 'success',
								size: 'small'
							},
							on: {
								click: () => {
									for(let k in this.initData.formData) {
										this.initData.formData[k] = (typeof params.row[k] === 'boolean' ? params.row[k].toString() : params.row[k]);
									}
									this.initData.showModal = true;
								}
							}
						}, '编辑'),
						h('Button', {
							props: {
								type: 'error',
								size: 'small'
							},
							style: {
								marginLeft: '10px'
							},
							on: {
								click: () => {
									this.handleDelete(params.row.id);
								}
							}
						}, '删除')
					])
				}
			}
		]
	}
	// 初始化
    init() {
    	// 获取部门信息
    	this.$store.dispatch('project/GetbearerOrg').then(() => {
    		this.initData.organizations = this.$store.state.project.bearerOrgId;
    	})
    }
    // 新增记录
    async handleSubmit() {
    	(this.$refs.form as any).validate(async (valid:boolean)=>{
            if(valid){
          		let datas:any = this.initData.formData;
          		let params:any = {};
          		for(let k in this.initData.formData) {
					if(k !== 'id') {
						if(k == 'happenDt' || k == 'reportDt') {
							params[k] = Tools.formatDate(datas[k]);
						}else{
							params[k] = datas[k];
						}
					} 
				}
            	this.initData.formLoading = true;
            	if(datas.id) {
            		params.id = datas.id;
            		await Ajax.put('/api/services/app/SafetyProduct/UpdateAccidentReportAsync', params).then((res:any)=>{
		                this.$Message.success('修改成功!');
		                this.initData.formLoading = false;
		                this.initData.showModal = false;
	                	(this as any).$refs.table.GetData();
		            }).catch(() => {
		            	this.initData.formLoading = false;
		            })
            	}else{
            		await Ajax.post('/api/services/app/SafetyProduct/CreateAccidentReportAsync', params).then((res:any)=>{
		                this.$Message.success('提交成功!');
		                this.initData.formLoading = false;
		                this.initData.showModal = false;
	                	(this as any).$refs.table.GetData();
		            }).catch(() => {
		            	this.initData.formLoading = false;
		            })
            	}
            }
        })
    }
    handleClearForm(flog:any) {
    	if(!flog) {
    		this.initData.showModal = false;
    		this.initData.formData.id = '';
    		(this as any).$refs.form.resetFields();
    	}
    }
    async handleDelete(id:any) {
    	this.$Modal.confirm({
            title: '操作确认',
            content: '是否确认删除此事故上报记录？',
            onOk: () => {
                Ajax.delete('/api/services/app/SafetyProduct/DeleteAccidentReportAsync', {params: {Id: id}}).then((res:any)=>{
	                this.$Message.success('删除成功!');
                	(this as any).$refs.table.GetData();
	            })
            }
        });
    }
    mounted() {
    	this.init();
    }
}
